import { render, staticRenderFns } from "./ProposalDetail.vue?vue&type=template&id=a6b89150&scoped=true&"
import script from "./ProposalDetail.vue?vue&type=script&lang=ts&"
export * from "./ProposalDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProposalDetail.vue?vue&type=style&index=0&id=a6b89150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b89150",
  null
  
)

component.options.__file = "ProposalDetail.vue"
export default component.exports